import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import axios from "axios";
import { set_page_refresh } from "../../redux/action.jsx";
import countriesData from "../../json/countries.json";
import socialMediaData from "../../json/socialMedia.json"; // Import the payment methods JSON
import { APIgetStores } from "../../../api/settings.ts";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const AddSocialMedia = () => {
  const dispatch = useDispatch();
 
  const MySwal = withReactContent(Swal);
  const [availableSocialMediaMethods, setAvailableSocialMediaMethods] = useState([]); // New state for available payment methods
  const [validationErrors, setValidationErrors] = useState({});
  const data = useSelector((state) => state.gateway_edit);
  const closeRef = useRef(null);
  const [showFacebookFields, setShowFacebookFields] = useState(false);
  const [showBankFields, setShowBankFields] = useState(false);// show instagram fields
  const [showLinkedInFields, setShowLinkedInFields] = useState(false);// show instagram fields
  const [showTwitterFields, setShowTwitterFields] = useState(false);// show instagram fields
  
  const [showTiktokFields, setShowTiktokFields] = useState(false);// show Tiktok fields
  const [showYoutubeFields, setShowYoutubeFields] = useState(false);// show youtube fields
  
  const [dataStore, setDataStore] = useState([]);
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const storeOptions = [
    // { value: '', label: 'Select Store' }, // Default option
    ...dataStore.map(store => ({
      value: store.value,
      label: store.label
    }))
  ];
  
  const [socialMedias, setSocialMedias] = useState({
    _id: "",
    country: "",
    stores: [],
    socialMediaMethods: [], // List of selected payment methods
    socialMediaDetails: [], // List of payment details per method
      facebook_ApiKey: "",
      facebook_SecretKey: "",
      facebook_token: "",

      instagram_ApiKey: "",
      instagram_SecretKey: "",
      instagram_token: "",

      linkedin_ApiKey: "",
      linkedin_SecretKey: "",
      linkedin_token: "",
      linkedin_personId: "",

      twitter_ApiKey: "",
      twitter_SecretKey: "",
      twitter_token: "",
      twitter_accessSecret: "",

      tiktok_ApiKey: "",
      tiktok_SecretKey: "",
      tiktok_token: "",

      youtube_ApiKey: "",
      youtube_SecretKey: "",
      youtube_token: "",
      
  });

  const countriesOptions = [
    { value: "select_country", label: "Select Country", name: "Select Country" },
    ...countriesData.map(country => ({
        value: country.name,
        label: t?.[l]?.[country.name] || country.name
    }))
];
  useEffect(() => {
    if (data && Object.keys(data).length) {
      setSocialMedias({
        _id: data._id,
        country: data.country,
        stores: data.stores || [],
        socialMediaMethods: data.socialMediaMethods || [],
        socialMediaDetails: data.socialMediaDetails || [],
        facebook_ApiKey: data.socialMediaDetails?.find(detail => detail.socialMediaType === "facebook")?.facebook_ApiKey || "",
        facebook_SecretKey: data.socialMediaDetails?.find(detail => detail.socialMediaType === "facebook")?.facebook_SecretKey || "",
        facebook_token: data.socialMediaDetails?.find(detail => detail.socialMediaType === "facebook")?.facebook_token || "",
        
        instagram_ApiKey: data.socialMediaDetails?.find(detail => detail.socialMediaType === "instagram")?.instagram_ApiKey || "",
        instagram_SecretKey: data.socialMediaDetails?.find(detail => detail.socialMediaType === "instagram")?.instagram_SecretKey || "",
        instagram_token: data.socialMediaDetails?.find(detail => detail.socialMediaType === "instagram")?.instagram_token || "",

        linkedin_ApiKey: data.socialMediaDetails?.find(detail => detail.socialMediaType === "linkedin")?.linkedin_ApiKey || "",
        linkedin_SecretKey: data.socialMediaDetails?.find(detail => detail.socialMediaType === "linkedin")?.linkedin_SecretKey || "",
        linkedin_token: data.socialMediaDetails?.find(detail => detail.socialMediaType === "linkedin")?.linkedin_token || "",
        linkedin_personId: data.socialMediaDetails?.find(detail => detail.socialMediaType === "linkedin")?.linkedin_personId || "",

        twitter_ApiKey: data.socialMediaDetails?.find(detail => detail.socialMediaType === "twitter")?.twitter_ApiKey || "",
        twitter_SecretKey: data.socialMediaDetails?.find(detail => detail.socialMediaType === "twitter")?.twitter_SecretKey || "",
        twitter_token: data.socialMediaDetails?.find(detail => detail.socialMediaType === "twitter")?.twitter_token || "",
        twitter_accessSecret:  data.socialMediaDetails?.find(detail => detail.socialMediaType === "twitter")?.twitter_accessSecret || "",
      
        tiktok_ApiKey: data.socialMediaDetails?.find(detail => detail.socialMediaType === "tiktok")?.tiktok_ApiKey || "",
        tiktok_SecretKey: data.socialMediaDetails?.find(detail => detail.socialMediaType === "tiktok")?.tiktok_SecretKey || "",
        tiktok_token: data.socialMediaDetails?.find(detail => detail.socialMediaType === "tiktok")?.tiktok_token || "",

        youtube_ApiKey: data.socialMediaDetails?.find(detail => detail.socialMediaType === "youtube")?.youtube_ApiKey || "",
        youtube_SecretKey: data.socialMediaDetails?.find(detail => detail.socialMediaType === "youtube")?.youtube_SecretKey || "",
        youtube_token: data.socialMediaDetails?.find(detail => detail.socialMediaType === "youtube")?.youtube_token || "",

      //
      
      });
      if(data.socialMediaDetails?.find(detail => detail.socialMediaType === "facebook"))
        setShowFacebookFields(true);
      if(data.socialMediaDetails?.find(detail => detail.socialMediaType === "instagram"))
        setShowBankFields(true);
      if(data.socialMediaDetails?.find(detail => detail.socialMediaType === "linkedin"))
        setShowLinkedInFields(true);
      if(data.socialMediaDetails?.find(detail => detail.socialMediaType === "twitter"))
        setShowTwitterFields(true);
      if(data.socialMediaDetails?.find(detail => detail.socialMediaType === "tiktok"))
        setShowTiktokFields(true);
      if(data.socialMediaDetails?.find(detail => detail.socialMediaType === "youtube"))
        setShowYoutubeFields(true);

      setAvailableSocialMediaMethods(socialMediaData[data.country] || []); // Set payment methods based on the country
    } else {
      resetForm();
    }
  }, [data]);

  useEffect(() => {
    const handleHidden = () => {
      // Reset the form state when the modal is hidden
      resetForm();
    };

    const modalElement = document.getElementById('add-brand');
    modalElement?.addEventListener('hidden.bs.modal', handleHidden);

    return () => {
      modalElement?.removeEventListener('hidden.bs.modal', handleHidden);
    };
  }, []);


  const resetForm = () => {
    setSocialMedias({
      _id: "",
      country: "",
      stores: [],
      socialMediaMethods: [],
      socialMediaDetails: [],
        facebook_ApiKey: "",
        facebook_SecretKey: "",
        facebook_token: "",

        instagram_ApiKey: "",
        instagram_SecretKey: "",
        instagram_token: "",

        linkedin_ApiKey: "",
        linkedin_SecretKey: "",
        linkedin_token: "",
        linkedin_personId: "",

        twitter_ApiKey: "",
        twitter_SecretKey: "",
        twitter_token: "",
        twitter_accessSecret: "",

        tiktok_ApiKey: "",
        tiktok_SecretKey: "",
        tiktok_token: "",

        youtube_ApiKey: "",
        youtube_SecretKey: "",
        youtube_token: "",
    });
    setShowBankFields(false)
    setShowFacebookFields(false)
    setShowLinkedInFields(false)
    setShowTwitterFields(false)
    setShowTiktokFields(false)
    setShowYoutubeFields(false)

    setAvailableSocialMediaMethods([]); // Reset available payment methods
  };

  useEffect(() => {
    getStoreApi();
  }, []);

  const getStoreApi = async () => {
    const res = await APIgetStores({});
    if (res?.response?.stores) {
      const storeData = res.response.stores.reverse();
      console.log("storeData", storeData);
      const storeOptions = storeData.map((store) => ({
        label: store.title,// "(" + store.storeNumber + ")", // storeNumber
        value: store._id,
        storeCode: store.storeNumber, // Store code
      }));
      setDataStore(storeOptions);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "country") {
      setSocialMedias((prevState) => ({
        ...prevState,
        country: value, // Update country
        socialMediaMethods: [], // Reset payment methods
        socialMediaDetails: [],

        facebook_ApiKey: "",
        facebook_SecretKey: "",
        facebook_token: "",

        instagram_ApiKey: "",
        instagram_SecretKey: "",
        instagram_token: "",

        linkedin_ApiKey: "",
        linkedin_SecretKey: "",
        linkedin_token: "",
        linkedin_personId: "",

        twitter_ApiKey: "",
        twitter_SecretKey: "",
        twitter_token: "",
        twitter_accessSecret: ""
      }));
      setAvailableSocialMediaMethods(socialMediaData[value] || []); // Set payment methods based on the selected country
    } else if (name === "storeId") {
      // eslint-disable-next-line no-debugger
      debugger;
      const selectedStores = value.map((id) => {
        const store = dataStore.find((s) => s.value == id);
        return store ? { storeId: id, storeCode: store.storeCode, storeName: store.label } : null;
      }).filter(Boolean); // Filter out any null values
    
      console.log("selectedStores", selectedStores);
    
      setSocialMedias((prevState) => ({
        ...prevState,
        stores: selectedStores,
      }));
    }
    else {
      setSocialMedias((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleCheckboxChange = (method, isChecked) => {
    setSocialMedias((prevState) => {
      const updatedMethods = isChecked
        ? [...prevState.socialMediaMethods, method] // Add method
        : prevState.socialMediaMethods.filter((m) => m !== method); // Remove method

        socialMedias.socialMediaDetails = socialMedias.socialMediaDetails?.filter(
          detail => detail.socialMediaType !== method
        );

      return {
        ...prevState,
        socialMediaMethods: updatedMethods,
      };
    });
  };


  const validateForm = () => {
    const errors = {};
  // eslint-disable-next-line no-debugger
  debugger;
    if (!socialMedias.country || socialMedias.country === "select_country") {
      errors.country = "Country is required.";
    }

    if (socialMedias.stores.length === 0) {
      errors.stores = "At least one store must be selected.";
    }

    if (socialMedias.socialMediaMethods.length === 0) {
      errors.socialMediaMethods = "At least one payment method must be selected.";
    }

    if (showFacebookFields) {
      const stripe = socialMedias.socialMediaDetails.find((detail) => detail.socialMediaType === "facebook");
      if (!stripe?.facebook_ApiKey) {
        errors.facebook_ApiKey = "Client Id is required.";
      }
      if (!stripe?.facebook_SecretKey) {
        errors.facebook_SecretKey = "Client Secret is required.";
      }if (!stripe?.facebook_token) {
        errors.facebook_token = "Token is required.";
      }
    }

    if (showBankFields) {
      const bank = socialMedias.socialMediaDetails.find((detail) => detail.socialMediaType === "instagram");
      if (!bank?.instagram_ApiKey) {
        errors.instagram_ApiKey = "Client Id is required.";
      }
      if (!bank?.instagram_SecretKey) {
        errors.instagram_SecretKey = "Client Secret is required.";
      }
      if (!bank?.instagram_token) {
        errors.instagram_token = "Token is required.";
      }
      
    
    }

  // eslint-disable-next-line no-debugger
  debugger;
    if (showLinkedInFields) { 
      const linked = socialMedias.socialMediaDetails.find((detail) => detail.socialMediaType === "linkedin");
      if (!linked?.linkedin_ApiKey) {
        errors.linkedin_ApiKey = "Client Id is required.";
      }
      if (!linked?.linkedin_SecretKey) {
        errors.linkedin_SecretKey = "Client Secret is required.";
      }
      if (!linked?.linkedin_token) {
        errors.linkedin_token = "Token is required.";
      }
      if (!linked?.linkedin_personId) {
        errors.linkedin_personId = "Person Id is required.";
      }
    }
    
    if (showTwitterFields) {
      const bank = socialMedias.socialMediaDetails.find((detail) => detail.socialMediaType === "twitter");
      if (!bank?.twitter_ApiKey) {
        errors.twitter_ApiKey = "Client Id is required.";
      }
      if (!bank?.twitter_SecretKey) {
        errors.twitter_SecretKey = "Client Secret is required.";
      }
      if (!bank?.twitter_token) {
        errors.twitter_token = "Access Token is required.";
      }
      if (!bank?.twitter_accessSecret) {
        errors.twitter_accessSecret = "Access Secret is required.";
      }
    }
    
    if (showTiktokFields) {
      const bank = socialMedias.socialMediaDetails.find((detail) => detail.socialMediaType === "tiktok");
      if (!bank?.tiktok_ApiKey) {
        errors.tiktok_ApiKey = "Client Id is required.";
      }
      if (!bank?.tiktok_SecretKey) {
        errors.tiktok_SecretKey = "Client Secret is required.";
      }
      if (!bank?.tiktok_token) {
        errors.tiktok_token = "Token is required.";
      }
    }

    if (showYoutubeFields) {
      const bank = socialMedias.socialMediaDetails.find((detail) => detail.socialMediaType === "youtube");
      if (!bank?.youtube_ApiKey) {
        errors.youtube_ApiKey = "Client Id is required.";
      }
      if (!bank?.youtube_SecretKey) {
        errors.youtube_SecretKey = "Client Secret is required.";
      }
      if (!bank?.youtube_token) {
        errors.youtube_token = "Token is required.";
      }
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const submit = async (event) => {
    event.preventDefault();
   {
      try {

        if(socialMedias.socialMediaMethods.includes("facebook"))
        {
          const { facebook_ApiKey, facebook_SecretKey, facebook_token } = socialMedias;

          const stripeDetails = {
            socialMediaType: "facebook",
            facebook_ApiKey,
            facebook_SecretKey,
            facebook_token
          };

          socialMedias.socialMediaDetails = socialMedias.socialMediaDetails?.filter(
            detail => detail.socialMediaType !== "facebook"
          );
          socialMedias.socialMediaDetails?.push(stripeDetails);
        }

        if(socialMedias.socialMediaMethods.includes("instagram"))
        {
          const { instagram_ApiKey, instagram_SecretKey, instagram_token } = socialMedias;
          socialMedias.socialMediaDetails = socialMedias.socialMediaDetails?.filter(
            detail => detail.socialMediaType !== "instagram"
          );
          socialMedias.socialMediaDetails?.push({
            socialMediaType: "instagram",
            instagram_ApiKey,
            instagram_SecretKey,
            instagram_token
          });
        }

        if(socialMedias.socialMediaMethods.includes("linkedin"))
        {
          const { linkedin_ApiKey, linkedin_SecretKey, linkedin_token, linkedin_personId } = socialMedias;

          const details = {
            socialMediaType: "linkedin",
            linkedin_ApiKey,
            linkedin_SecretKey,
            linkedin_token,
            linkedin_personId
          };

          socialMedias.socialMediaDetails = socialMedias.socialMediaDetails?.filter(
            detail => detail.socialMediaType !== "linkedin"
          );
          socialMedias.socialMediaDetails?.push(details);
        }

        if(socialMedias.socialMediaMethods.includes("twitter"))
          {
            const { twitter_ApiKey, twitter_SecretKey, twitter_token,twitter_accessSecret } = socialMedias;
  
            const details = {
              socialMediaType: "twitter",
              twitter_ApiKey,
              twitter_SecretKey,
              twitter_token,
              twitter_accessSecret
            };
  
            socialMedias.socialMediaDetails = socialMedias.socialMediaDetails?.filter(
              detail => detail.socialMediaType !== "twitter"
            );
            socialMedias.socialMediaDetails?.push(details);
          }
        
        if(socialMedias.socialMediaMethods.includes("tiktok"))
        {
          const { tiktok_ApiKey, tiktok_SecretKey, tiktok_token } = socialMedias;
          socialMedias.socialMediaDetails = socialMedias.socialMediaDetails?.filter(
            detail => detail.socialMediaType !== "tiktok"
          );
          socialMedias.socialMediaDetails?.push({
            socialMediaType: "tiktok",
            tiktok_ApiKey,
            tiktok_SecretKey,
            tiktok_token
          });
        }

        if(socialMedias.socialMediaMethods.includes("youtube"))
        {
          const { youtube_ApiKey, youtube_SecretKey, youtube_token } = socialMedias;
          socialMedias.socialMediaDetails = socialMedias.socialMediaDetails?.filter(
            detail => detail.socialMediaType !== "youtube"
          );
          socialMedias.socialMediaDetails?.push({
            socialMediaType: "youtube",
            youtube_ApiKey,
            youtube_SecretKey,
            youtube_token
          });
        }
        //
         
          if (validateForm()) 
          {
            delete socialMedias.instagram_ApiKey;
            delete socialMedias.instagram_SecretKey;
            delete socialMedias.instagram_token;
            
          
            delete socialMedias.facebook_ApiKey;
            delete socialMedias.facebook_SecretKey;
            delete socialMedias.facebook_token;

            delete socialMedias.linkedin_ApiKey;
            delete socialMedias.linkedin_SecretKey;
            delete socialMedias.linkedin_token;
            delete socialMedias.linkedin_personId;

            delete socialMedias.twitter_ApiKey;
            delete socialMedias.twitter_SecretKey;
            delete socialMedias.twitter_token;
            delete socialMedias.twitter_accessSecret;
            
            delete socialMedias.tiktok_ApiKey;
            delete socialMedias.tiktok_SecretKey;
            delete socialMedias.tiktok_token;

            delete socialMedias.youtube_ApiKey;
            delete socialMedias.youtube_SecretKey;
            delete socialMedias.youtube_token;

            
           
          try {
            await axios.post("addorupdatesocialmedia/", socialMedias);
            MySwal.fire({
              position: "top-end",
              icon: "success",
              title: "Created Successfully!",
              showConfirmButton: false,
              timer: 3000,
              })
          }
          catch(error)
          {
            console.error("Error submitting payment gateway:", error);
            MySwal.fire({
              position: "top-end",
              icon: "error",
              title: error.response.data.message,
              showConfirmButton: false,
              timer: 3000,
            });  
          }
            resetForm();
            closeRef.current?.click();
            dispatch(set_page_refresh("paymentConfigs"));
          }
        
      } catch (error) {
        console.error("Error submitting payment gateway:", error);
        MySwal.fire({
          position: "top-end",
          icon: "error",
          title: error.response.data.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }

  };

  return (
    <div className="modal fade" id="add-brand">
      <div className="modal-dialog modal-dialog-centered custom-modal-two modal-xl">
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content">
              <div className="modal-header border-0 custom-modal-header">
                <h4>
                  {Object.keys(data || {}).length
                    ? t?.[l]?.["edit_social_media"] || "Edit Social Media"
                    : t?.[l]?.["add_social_media"] || "Add Social Media"}
                </h4>
                <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body custom-modal-body new-employee-field">
                <form onSubmit={submit}>
                  {/* Country Dropdown */}
                  <div className="mb-3">
                    <label className="form-label">
                      {t?.[l]?.["select_a_country_to_populate_its_social_media_options"] || "Select a country to populate its social media options"} <span>*</span>
                    </label>
                    <Select
                      className="select"
                      options={countriesOptions}
                      name="country"
                      value={countriesOptions.find(option => option.value === socialMedias.country) || countriesOptions[0]} // Default to the first country option if no match
                      onChange={(selectedOption) => {
                        handleInputChange({ target: { name: "country", value: selectedOption.value } });
                      }}
                    />
                    {validationErrors.country && <p className="text-danger">{validationErrors.country}</p>}
                  </div>
          
                  {/* Conditional Fields for Bank Transfer and Stripe */}

                {availableSocialMediaMethods && availableSocialMediaMethods.includes("instagram") &&(
                  <>
                  <div key="instagram" className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={showBankFields && socialMedias.socialMediaMethods.includes("instagram")}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setShowBankFields(isChecked); // Update showBankFields state
                        handleCheckboxChange("instagram", isChecked); // Update socialMediaMethods
                      }}
                    />
                    <label htmlFor="checkbox-instagram" className="form-check-label">
                    {t?.[l]?.["instagram"] || "Instagram" }
                    </label>
                  </div>
                  <hr />       
                    {showBankFields && socialMedias.socialMediaMethods.includes("instagram") && (
                      <>
                    <div className="d-flex flex-wrap">
                      <div className="mb-3 me-3">
                        <label className="form-label">{t?.[l]?.["client_id"] || "Client ID"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="instagram_ApiKey"
                          value={socialMedias.instagram_ApiKey}
                          maxLength={500}
                          onChange={handleInputChange}
                          
                        />
                         {validationErrors.instagram_ApiKey && <p className="text-danger">{validationErrors.instagram_ApiKey}</p>}
           
                      </div>
                      <div className="mb-3 me-3">
                        <label className="form-label">{t?.[l]?.["client_secret"] || "Client Secret"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="instagram_SecretKey"
                          value={socialMedias.instagram_SecretKey}
                          maxLength={500}
                          onChange={handleInputChange}
                          
                        />
                         {validationErrors.instagram_SecretKey && <p className="text-danger">{validationErrors.instagram_SecretKey}</p>}
                      </div>   
                      <div className="mb-3 me-3">
                        <label className="form-label">{t?.[l]?.["token"] || "Token"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="instagram_token"
                          value={socialMedias.instagram_token}
                          onChange={handleInputChange}
                          
                        />
                         {validationErrors.instagram_token && <p className="text-danger">{validationErrors.instagram_token}</p>}
                      </div> 
                      
                    </div>
                    <hr />
                     </>
                  )} 
                 
                  </>
                )}
                {availableSocialMediaMethods && availableSocialMediaMethods.includes("facebook") &&(
                  <>
                  <div key="facebook" className="form-check">
                    <input
                    type="checkbox"
                    className="form-check-input"
                    checked={showFacebookFields || socialMedias.socialMediaMethods.includes("facebook")}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setShowFacebookFields(isChecked); // Update showBankFields state
                        handleCheckboxChange("facebook", isChecked); // Update socialMediaMethods
                      }}                  
                    />
                   
                    <label htmlFor="checkbox-stripe" className="form-check-label">
                    {t?.[l]?.["facebook"] || "Facebook" }
                    </label>
                  </div>
                  <hr />
                  {/* {socialMedias.paymentMethod === "facebook" && ( */}
                  {showFacebookFields && (
                    <div className="d-flex flex-wrap">
                      <div className="mb-3 me-2">
                        <label className="form-label">{t?.[l]?.["client_id"] || "Client ID"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="facebook_ApiKey"
                          value={socialMedias.facebook_ApiKey}
                          onChange={handleInputChange}
                          maxLength={500}
                          
                        />
                           {validationErrors.facebook_ApiKey && <p className="text-danger">{validationErrors.facebook_ApiKey}</p>}
        
                      </div>
                      <div className="mb-3 me-2">
                        <label className="form-label">{t?.[l]?.["client_secret"] || "Client Secret"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="facebook_SecretKey"
                          value={socialMedias.facebook_SecretKey}
                          onChange={handleInputChange}
                          maxLength={500}
                          
                        />
                        {validationErrors.facebook_SecretKey && <p className="text-danger">{validationErrors.facebook_SecretKey}</p>}
       
                      </div>
                      <div className="mb-3 me-2">
                        <label className="form-label">{t?.[l]?.["token"] || "Token"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="facebook_token"
                          value={socialMedias.facebook_token}
                          onChange={handleInputChange}
                          
                        />
                        {validationErrors.facebook_token && <p className="text-danger">{validationErrors.facebook_token}</p>}
       
                      </div>
                      
                      <hr />
                    </div>
                  )}
                  
                  </>
                )}

                {availableSocialMediaMethods && availableSocialMediaMethods.includes("linkedin") &&(
                  <>
                  <div key="linkedin" className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={showLinkedInFields && socialMedias.socialMediaMethods.includes("linkedin")}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setShowLinkedInFields(isChecked); // Update showLinkedInFields state
                        handleCheckboxChange("linkedin", isChecked); // Update socialMediaMethods
                      }}
                    />
                    <label htmlFor="checkbox-linkedin" className="form-check-label">
                    {t?.[l]?.["linkedin"] || "Linked In" }
                    </label>
                  </div>
                  <hr />       
                    {showLinkedInFields && socialMedias.socialMediaMethods.includes("linkedin") && (
                      <>
                    <div className="d-flex flex-wrap">
                      <div className="mb-3 me-3">
                        <label className="form-label">{t?.[l]?.["client_id"] || "Client ID"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="linkedin_ApiKey"
                          value={socialMedias.linkedin_ApiKey}
                          maxLength={500}
                          onChange={handleInputChange}
                          
                        />
                         {validationErrors.linkedin_ApiKey && <p className="text-danger">{validationErrors.linkedin_ApiKey}</p>}
           
                      </div>
                      <div className="mb-3 me-3">
                        <label className="form-label">{t?.[l]?.["client_secret"] || "Client Secret"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="linkedin_SecretKey"
                          value={socialMedias.linkedin_SecretKey}
                          maxLength={500}
                          onChange={handleInputChange}
                          
                        />
                         {validationErrors.linkedin_SecretKey && <p className="text-danger">{validationErrors.linkedin_SecretKey}</p>}
                      </div>   
                      <div className="mb-3 me-3">
                        <label className="form-label">{t?.[l]?.["token"] || "Token"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="linkedin_token"
                          value={socialMedias.linkedin_token}
                          onChange={handleInputChange}
                          
                        />
                         {validationErrors.linkedin_token && <p className="text-danger">{validationErrors.linkedin_token}</p>}
                      </div> 

                      <div className="mb-3 me-3">
                        <label className="form-label">{t?.[l]?.["linkedin_personId"] || "Linkedin PersonId"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="linkedin_personId"
                          value={socialMedias.linkedin_personId}
                          onChange={handleInputChange}
                        />
                         {validationErrors.linkedin_personId && <p className="text-danger">{validationErrors.linkedin_personId}</p>}
                      </div>
                      
                    </div>
                    <hr />
                     </>
                  )} 
                  
                 
                  </>
                )}

                {availableSocialMediaMethods && availableSocialMediaMethods.includes("twitter") &&(
                  <>
                  <div key="twitter" className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={showTwitterFields && socialMedias.socialMediaMethods.includes("twitter")}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setShowTwitterFields(isChecked); // Update showLinkedInFields state
                        handleCheckboxChange("twitter", isChecked); // Update socialMediaMethods
                      }}
                    />
                    <label htmlFor="checkbox-twitter" className="form-check-label">
                    {t?.[l]?.["twitter"] || "Twitter" }
                    </label>
                  </div>
                  <hr />       
                    {showTwitterFields && socialMedias.socialMediaMethods.includes("twitter") && (
                      <>
                    <div className="d-flex flex-wrap">
                      <div className="mb-3 me-3">
                        <label className="form-label">{t?.[l]?.["client_id"] || "Client ID"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="twitter_ApiKey"
                          value={socialMedias.twitter_ApiKey}
                          maxLength={500}
                          onChange={handleInputChange}
                          
                        />
                         {validationErrors.twitter_ApiKey && <p className="text-danger">{validationErrors.twitter_ApiKey}</p>}
           
                      </div>
                      <div className="mb-3 me-3">
                        <label className="form-label">{t?.[l]?.["client_secret"] || "Client Secret"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="twitter_SecretKey"
                          value={socialMedias.twitter_SecretKey}
                          maxLength={500}
                          onChange={handleInputChange}
                          
                        />
                         {validationErrors.twitter_SecretKey && <p className="text-danger">{validationErrors.twitter_SecretKey}</p>}
                      </div>   
                      <div className="mb-3 me-3">
                        <label className="form-label">{t?.[l]?.["access_token"] || "Access Token"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="twitter_token"
                          value={socialMedias.twitter_token}
                          onChange={handleInputChange}
                          
                        />
                         {validationErrors.twitter_token && <p className="text-danger">{validationErrors.twitter_token}</p>}
                      </div>     
                      <div className="mb-3 me-3">
                        <label className="form-label">{t?.[l]?.["access_secret"] || "Access Secret"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="twitter_accessSecret"
                          value={socialMedias.twitter_accessSecret}
                          onChange={handleInputChange}
                          
                        />
                         {validationErrors.twitter_accessSecret && <p className="text-danger">{validationErrors.twitter_accessSecret}</p>}
                      </div>                      
                    </div>
                    <hr />
                     </>
                  )} 
                  
                 
                  </>
                )}

                {availableSocialMediaMethods && availableSocialMediaMethods.includes("tiktok") &&(
                  <>
                  <div key="tiktok" className="form-check">
                    <input
                    type="checkbox"
                    className="form-check-input"
                    checked={showTiktokFields || socialMedias.socialMediaMethods.includes("tiktok")}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setShowTiktokFields(isChecked); // Update showBankFields state
                        handleCheckboxChange("tiktok", isChecked); // Update socialMediaMethods
                      }}                  
                    />
                   
                    <label htmlFor="checkbox-stripe" className="form-check-label">
                    {t?.[l]?.["tiktok"] || "Tiktok" }
                    </label>
                  </div>
                  <hr />
               
                  {showTiktokFields && (
                    <div className="d-flex flex-wrap">
                      <div className="mb-3 me-2">
                        <label className="form-label">{t?.[l]?.["client_id"] || "Client ID"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="tiktok_ApiKey"
                          value={socialMedias.tiktok_ApiKey}
                          onChange={handleInputChange}
                          maxLength={500}
                          
                        />
                           {validationErrors.tiktok_ApiKey && <p className="text-danger">{validationErrors.tiktok_ApiKey}</p>}
        
                      </div>
                      <div className="mb-3 me-2">
                        <label className="form-label">{t?.[l]?.["client_secret"] || "Client Secret"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="tiktok_SecretKey"
                          value={socialMedias.tiktok_SecretKey}
                          onChange={handleInputChange}
                          maxLength={500}
                          
                        />
                        {validationErrors.tiktok_SecretKey && <p className="text-danger">{validationErrors.tiktok_SecretKey}</p>}
       
                      </div>
                      <div className="mb-3 me-2">
                        <label className="form-label">{t?.[l]?.["token"] || "Token"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="tiktok_token"
                          value={socialMedias.tiktok_token}
                          onChange={handleInputChange}
                          
                        />
                        {validationErrors.tiktok_token && <p className="text-danger">{validationErrors.tiktok_token}</p>}
       
                      </div>
                      
                      <hr />
                    </div>
                  )}
                  </>
                )}

                {availableSocialMediaMethods && availableSocialMediaMethods.includes("youtube") &&(
                  <>
                  <div key="youtube" className="form-check">
                    <input
                    type="checkbox"
                    className="form-check-input"
                    checked={showYoutubeFields || socialMedias.socialMediaMethods.includes("youtube")}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setShowYoutubeFields(isChecked); // Update showBankFields state
                        handleCheckboxChange("youtube", isChecked); // Update socialMediaMethods
                      }}                  
                    />
                   
                    <label htmlFor="checkbox-stripe" className="form-check-label">
                    {t?.[l]?.["youtube"] || "Youtube" }
                    </label>
                  </div>
                  <hr />
               
                  {showYoutubeFields && (
                    <div className="d-flex flex-wrap">
                      <div className="mb-3 me-2">
                        <label className="form-label">{t?.[l]?.["client_id"] || "Client ID"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="youtube_ApiKey"
                          value={socialMedias.youtube_ApiKey}
                          onChange={handleInputChange}
                          maxLength={500}
                          
                        />
                           {validationErrors.youtube_ApiKey && <p className="text-danger">{validationErrors.youtube_ApiKey}</p>}
        
                      </div>
                      <div className="mb-3 me-2">
                        <label className="form-label">{t?.[l]?.["client_secret"] || "Client Secret"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="youtube_SecretKey"
                          value={socialMedias.youtube_SecretKey}
                          onChange={handleInputChange}
                          maxLength={500}
                          
                        />
                        {validationErrors.youtube_SecretKey && <p className="text-danger">{validationErrors.youtube_SecretKey}</p>}
       
                      </div>
                      <div className="mb-3 me-2">
                        <label className="form-label">{t?.[l]?.["token"] || "Token"}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="youtube_token"
                          value={socialMedias.youtube_token}
                          onChange={handleInputChange}
                          
                        />
                        {validationErrors.youtube_token && <p className="text-danger">{validationErrors.youtube_token}</p>}
       
                      </div>
                      
                      <hr />
                    </div>
                  )}
                  </>
                )}
                  {/* Store Dropdown */}
                  <div className="mb-3">
                    <label className="form-label">
                      {t?.[l]?.["store"] || "Store"} <span>*</span>
                    </label>

                    <Select
                      className="select"
                      options={storeOptions}
                      name="storeId"
                      isMulti
                      placeholder="Select Store" // or any dynamic placeholder like {chooseStore}
                      value={socialMedias.stores.map(store => ({
                        value: store.storeId,
                        label: store.storeName,
                      }))}
                      onChange={(e) => handleInputChange({ target: { name: 'storeId', value: e.map(store => store.value) } })}
                    
                    />
                       {validationErrors.stores && <p className="text-danger">{validationErrors.stores}</p>}
                     
                  </div>
                  <div className="modal-footer-btn">
                     <button type="button" className="btn btn-cancel me-2" data-bs-dismiss="modal" ref={closeRef}>{t?.[l]?.["cancel"] || "Cancel"}</button>
                     <button type="submit" className="btn btn-submit">{t?.[l]?.["save"] || "Save"}</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSocialMedia;